import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
//全局样式
// 导入全局样式表
import './assets/css/global.css';
// 加入性能监控分析配置
import './config/monitor.config'
//使用element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入本地缓存的方法
import storage from './utils/storage';
import JsonExcel from 'vue-json-excel'
 
Vue.component('downloadExcel', JsonExcel)
Vue.prototype.$storage = storage;
// Vue.prototype.option = webSelectorPlugin
Vue.prototype.$message = function(msg){
  ElementUI.Message({ ...msg, duration: 1500 })
}
Vue.use(ElementUI);

import mixins from './mixins';
Vue.mixin(mixins);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
